import { render, staticRenderFns } from "./BaseCopy.vue?vue&type=template&id=4088a44f&scoped=true"
import script from "./BaseCopy.vue?vue&type=script&lang=js"
export * from "./BaseCopy.vue?vue&type=script&lang=js"
import style0 from "./BaseCopy.vue?vue&type=style&index=0&id=4088a44f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4088a44f",
  null
  
)

export default component.exports